import { render, staticRenderFns } from "./keyboardEmojiSelector.vue?vue&type=template&id=52729c52&"
import script from "./keyboardEmojiSelector.vue?vue&type=script&setup=true&lang=js&"
export * from "./keyboardEmojiSelector.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52729c52')) {
      api.createRecord('52729c52', component.options)
    } else {
      api.reload('52729c52', component.options)
    }
    module.hot.accept("./keyboardEmojiSelector.vue?vue&type=template&id=52729c52&", function () {
      api.rerender('52729c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/WootWriter/keyboardEmojiSelector.vue"
export default component.exports